import BasicTabs from '../components/wavemill/BasicTabs'

export default function Wavemill() {
  return (

  <div className="container">   
    <div className="page">
      <section>
        <h2 className='align_center'>       
          Wave Mill Ocean Wave Energy Platform     
        </h2>      
      </section>

      <BasicTabs />
    </div>
  </div>
  )
}
